<template>
  <div class="p">
    <div v-if="subjectList.length>0">
      <header class="p-header" ref="header">
      <ul class="p-header__subject">
        <li
          v-for="(item, index) in subjectList"
          :key="item.subject_id"
          :class="{'isactive': item.active}"
          @click="subjectChange(index)"
        >
          {{item.subject_name}}
        </li>
      </ul>
       <div class="week-picker-wrapper">
        <el-date-picker
          ref="weekPicker"
          popper-class="picker-ppp"
          @change="pickChange"
          v-model="dateRange"
          type="week"
          value-format="yyyy-MM-dd"
          range-separator="至"
          :default-value="Date.now() - 29 * 24 * 3600 * 1000"
          :picker-options="pickerOptions"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="week-picker-input"
          >
        </el-date-picker>
        <div class="week-picker-display" @click="openWeekPicker">
          <i class="el-icon-date"></i>
          <span>{{ weekDisplayText }}</span>
        </div>
      </div>
    </header>
    <div @click="updateVisible">
      <CheckDetail title="查看明细" class="check-detail" />
    </div>
    <DialogContent :dialogVisible.sync="dialogVisible" title="班级近况明细" type= 3 ref="dialogContent"
     :studyResults="totalList"
    />
    <ClassRecent
      :subjectId="subjectId"
      :studyResults="totalList"
      titleNumber="1"
      titleName="''"
      @clickItem="clickItem"
    />
    </div>
    <div v-else>
      <empty content="暂无数据～" />
    </div>
    <!-- <div class="overview-head">
      <div class="overview-head__num">03</div>
      <div class="overview-head__title">课程学习人数分布</div>
    </div> -->
    <!-- <div class="p-people">课程学习人数分布</div> -->
    <!-- 人数分布柱折图 -->
    <!-- <div v-show="numDistributionList && numDistributionList.length < 1">
      <empty content="暂无课程学习数据～" />
    </div>
    <div v-show="numDistributionList && numDistributionList.length > 0"
      id="myecharts" ref="myecharts"></div> -->
    <EffectAnalysis :effect="effect" :schoolMasterClassId="masterClassId" />
    <KnowledgeDetail
      :subjectId="subjectId"
      :detailList="detailList"
      :dataCount="dataCount"
      @sizeChange="knowledgeSizeChange"
      @currentChange="knowledgeCurrentChange"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import ClassRecent from './class-recent.vue';
import CheckDetail from './check-detail.vue';
import Empty from '@/views/pt/components/empty.vue';
import {
  getSubjectCourseList, getClassSituation,
  tagCodeStudySituation, getKnowledgeDetailsAction,
} from '@/api/pt';
import { unlocking } from '@/utils/access-control';
import DialogContent from './dialog-content.vue';
import KnowledgeDetail from './knowledge-detail.vue';
import EffectAnalysis from './effect-analysis.vue';

export default {
  name: 'CourseEcharts',
  components: {
    ClassRecent,
    Empty,
    CheckDetail,
    DialogContent,
    KnowledgeDetail,
    EffectAnalysis,
  },
  props: {
    classId: {},
    masterClassId: {},
  },
  data() {
    const getDefaultWeekRange = () => {
      const today = dayjs();
      const day = today.day();
      const monday = day === 0 ? today.subtract(6, 'day') : today.subtract(day - 1, 'day');
      // type="week" 时，返回周一日期对象；为了兼容，也可以返回数组
      return monday.toDate();
    };
    return {
      subjectList: [],
      value: '选项1',
      subjectId: null,
      crmSubjectId: null,
      value1: '',
      startDate: null,
      endDate: null,
      startTime: null,
      endTime: null,
      totalList: {},
      format: '',
      numDistributionList: [],
      dateRange: getDefaultWeekRange(),
      pickerMinDate: '',
      pickerOptions: {
        firstDayOfWeek: 1,
        // disabledDate: (time) => {
        //   if (this.pickerMinDate !== '') {
        //     const day30 = (30 - 1) * 24 * 3600 * 1000;
        //     let maxTime = this.pickerMinDate + day30;
        //     if (maxTime > new Date()) {
        //       maxTime = new Date();
        //       return time.getTime() > maxTime || time.getTime() < this.pickerMinDate - day30;
        //     }
        //     return maxTime < time.getTime() || time.getTime() < this.pickerMinDate - day30;
        //   }
        //   return time.getTime() > Date.now();
        // },

      },
      dialogVisible: false,
      detailList: [],
      effect: {}, // 学习效果分析
      pageSize: 10,
      currentPage: 1,
      dataCount: 0,
    };
  },
  mounted() {
    this.getSubjectCourseList();
  },
  computed: {
    weekDisplayText() {
      if (!this.dateRange) {
        return '请选择日期';
      }
      let selectedDate;
      if (Array.isArray(this.dateRange)) {
        if (this.dateRange.length < 1) {
          return '请选择日期';
        }
        const [firstDate] = this.dateRange;
        selectedDate = firstDate;
      } else {
        selectedDate = this.dateRange;
      }
      const [weekStart, weekEnd] = this.getAlignedWeekRange(selectedDate);
      return `${weekStart.format('YYYY-MM-DD')} 至 ${weekEnd.format('YYYY-MM-DD')}`;
    },
  },
  watch: {
    numDistributionList() {
      this.openEcharts();
    },
    classId() {
      this.getSubjectCourseList();
    },
  },
  methods: {
    getSubjectCourseList() { // 获取科目列表
      getSubjectCourseList({
        class_id: this.classId,
        grade_id: this.$attrs.gradeId,
        school_master_class_id: this.masterClassId,
        is_charge: unlocking('Master_Sale_Manager') ? 1 : 0,
        is_filter: 0,
      }).then((res) => {
        this.subjectList = res.data.subject_list;
        this.$set(this.subjectList[0], 'active', true);
        this.$emit('getSubjectList', this.subjectList);
        console.log(this.subjectList, 'this.subjectListxxxxxxxxxx');
        this.$store.commit('SET_CLASS_SUBJECT_LIST', this.subjectList);
        sessionStorage.setItem('knowSubjectList', JSON.stringify(this.subjectList));
        this.$store.commit('SET_KNOW_SUBJECT_LIST', this.subjectList);
        this.subjectId = this.subjectList[0].subject_id;
        this.$store.commit('SET_CLASS_SUBJECT_ID', this.subjectId);
        this.crmSubjectId = this.subjectList[0].crm_subject_id;
        this.pickChange();
      }).catch((err) => {
        console.log(err);
      });
    },
    subjectChange(index) { // 科目切换
      this.subjectList.forEach((item) => {
        this.$set(item, 'active', false);
      });
      this.$set(this.subjectList[index], 'active', true);
      this.subjectId = this.subjectList[index].subject_id;
      this.$store.commit('SET_CLASS_SUBJECT_ID', this.subjectId);
      this.crmSubjectId = this.subjectList[index].crm_subject_id;
      this.getClassSituation();
      this.tagCodeStudySituation();
      this.queryKnowledgeDetailsAction();
    },
    async getClassSituation() { // 班级近况
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
      try {
        const params = {
          class_id: this.classId,
          school_master_class_id: this.masterClassId,
          school_id: userInfo.campusId || 20022,
          crm_subject_id: this.crmSubjectId,
          subject_id: this.subjectId,
          start_time: this.startTime,
          end_time: this.endTime,
        };
        this.$store.commit('SET_LEARN_DETAIL_OBJ', params);
        const res = await getClassSituation(params);
        this.totalList = res.data;
        this.numDistributionList = res.data.num_distribution_list;
        this.$emit('getTableList', this.totalList, this.subjectId);
      } catch (error) {
        console.log(error);
      }
    },
    openEcharts() { // 柱状图和折线图
      const chartDom = document.getElementById('myecharts');
      const myChart = this.$echarts.init(chartDom);
      const option = {
        grid: {
          left: '5%',
        },
        tooltip: {
          trigger: 'axis',
          enterable: true, // 鼠标可以进入
          // triggerOn: 'click', // 可点击
          // axisPointer: {
          //   type: 'cross',
          //   crossStyle: {
          //     color: '#1890FF',
          //   },
          // },
          formatter: (params) => {
            // const color = 'black';// 图例颜色
            let htmlStr = '<div>';
            htmlStr += `<div style="color:#1890FF">${params[0].axisValue}</div><br/>`;// x轴的名称
            // 为了保证和原来的效果一样，这里自己实现了一个点的效果
            // htmlStr += `<span style="margin-right:5px;display:inline-block;
            // width:10px;height:10px;border-radius:5px;background-color:${color};"></span>`;
            // 文本颜色设置--2020-07-23(需要设置,请解注释下面一行)
            // htmlStr += '<span style="color:'+color+'">';
            // 添加一个汉字，这里你可以格式你的数字或者自定义文本内容
            htmlStr += `学习人数：${params[0].data}人</br>人均学习时长：${params[1].data} 分钟`;
            // 文本颜色设置--2020-07-23(需要设置,请解注释下面一行)
            // htmlStr += '</span>';
            htmlStr += '</ div>';
            htmlStr += '</div>';
            return htmlStr;
          },
        },
        legend: {
          data: [{
            name: '学习人数',
            icon: 'roundRect',
          }, {
            name: '人均学习时长',
            icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAgCAYAAAB3j6rJAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIqADAAQAAAABAAAAIAAAAAB4uvI0AAAEYElEQVRYCcVXW2hcVRRd5840Jo1N60ex8yAFUQOCKaYRBfthsZ8FP2pKVCwtVFpi0tQfMYKWakULfiTj1HaURqwgNOmXICjFx4eCIgWNWGqQ1kemU1GsfcQkbeZu174z5+bOK73TOno+cvbeZz/WWXefcybAfzCSY9JyrTLOtRz+jfX5HPYn03LfYrkaDqTjsCyDYGs+j8yDn0q0FpiGA7l0GVtYfJkI1kx+h6f/NyAC9Nniros9sbSstnpwbigjiRFZTybuChRslTzSAd0XGwrEBZ7yK1lBsDE2LJusaueGAUkelATZeNgWMgYfWpnziNfEAUPDgLhXsIN17Cn5pKUZvTA4p7XZN4mLl7AvgAOLAlmdkZiImGBAGHltRpbwszxpfY2DA6d3mAuOg93WRjD9sRFZa/VFgczNYiiZQo91DjvnZrGJ216l/txFtuNuvK/y2QFzlPpHKnM49HmzZ0wiBcWzVf7Ra9kInuDO9i12EVVGetQvNKmDQ5+tN/PWb0kT+ghmRnWy0vV5Dv0q12TEzaGXjivYcHf8MIHt6hxmJIelkzHrPF+Dq80u3grG/dJnTpOml4q2eX745SrXBiJes3n+TPxCPCNLi8GLTnmzcGTJ6LEzu81v5QHxZrzmGLwTjaDr3C7zoq5XbcREStbkXXwTTMDj91xu0LwStJXLt2Vk+d8zyNLeqmtOBOvYF1+U+1XTqzJCBvTolQ7BM+1vyC2lxlJtZhZbafFAEPi3YUFolgognUeklQ36uC7qIGV/6qz9cuUqnlW52igec/9dYeCBan61bBVA/jiPR1m1TQO4q1PiLLDDbz6gN2a1ZIkRbCCTd3prBhdWrsB71fxq2SqAlHwWgwyb6RgBfa0JyEpLfg57qiVj9/tHloDfnthipqv51bKVAImnpYvFutWZxWcjS3FEZToN6ayD69sSaSnsvGBCfETaad/oqQbiRHGwuBR6KgHCJzrYpONT243XH9lB8zGBHS9mjbp5vBysQBA7idC7IdlTx7P9ZjK4Hkb2gehryISP2SC+DxkrF+chNiBdyIrgkdjr4jF3e0puosm/8PRdKfrXNflALk4ThODmYvT35UePd8gJro3b7OLiVZWnXfQQ2EqVydrPD9yKD1Sud/hACML/LLz1ytnw8kYieJ5C4d0QPBRPyYaSJgUOjW82+XpBqL8HZNWw3Mtd3aMGfZCa2vCuyuVDvz13PWrtjDnMDdyvOu1zrqF+ncMDwiQ+G2yCoz9tM3/Vyhd1sFfB6jqBtAf8xnjUfw/odYkOm62NCXttVKSySe2SN/86YM4SbKrESIWf7bqa1OZxLgNJMnLKMxhMZHeZL+1irbmpCfvJis8a409M9ZuvavmHsTuk8yRPRDeTdZP2wTBB/E1xnsfUOzXqT1A3xEYxR5jSlT76C47/0/7I67w5EkdyarPx+qbSM5xl4fiG8/e9tDCZ2EsmR28UhCa1P/f9AvUIHZ0YPTNZuMzqiavm+w+Gm06BJkbpagAAAABJRU5ErkJggg==',
          }],
          left: '70%',
          itemWidth: 12,
          itemHeight: 12,
        },
        dataZoom: [// 给x轴设置滚动条
          {
            startValue: 0,
            endValue: 9,
            type: 'slider',
            show: true,
            xAxisIndex: [0],
            handleSize: 10, // 滑动条的 左右2个滑动条的大小
            height: 10, // 组件高度
            left: '0%', // 左边的距离
            right: '0%', // 右边的距离
            bottom: 1, // 右边的距离
            borderColor: '#000',
            fillerColor: '#269cdb',
            borderRadius: 5,
            backgroundColor: '#33384b', // 两边未选中的滑动条区域的颜色
            showDataShadow: false, // 是否显示数据阴影 默认auto
            showDetail: false, // 即拖拽时候是否显示详细数值信息 默认true
            realtime: true, // 是否实时更新
            filterMode: 'filter',
          },
          // 下面这个属性是里面拖到
          {
            type: 'inside',
            show: true,
            xAxisIndex: [0],
            start: 0, // 默认为1
            end: 100 - 1500 / 31, // 默认为100
            zoomLock: true,
          },
        ],
        xAxis: [
          {
            type: 'category',
            data: this.numDistributionList
            && this.numDistributionList.map((item) => item.course_name),
            axisPointer: {
              type: 'shadow',
              textStyle: {
                color: '#1890FF',
              },

            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '人数',
            nameTextStyle: {
              align: 'right',
              padding: [0, 0, 15, 0],
            },
            min: 0,
            // max: 100,
            interval: 10,
            axisLabel: {
              formatter: '{value}',
            },
          },
          {
            type: 'value',
            show: false,
            min: 0,
            name: '时间',
            nameTextStyle: {
              align: 'right',
              padding: [0, -30, 0, 0],
            },
            // max: ,
            interval: 20,
          },
        ],
        series: [
          {
            name: '学习人数',
            type: 'bar',
            barWidth: 10,
            itemStyle: {
              normal: {
                color: '#1890FF',
                label: {
                  show: true, // 开启显示
                  position: 'top', // 在上方显示
                  textStyle: { // 数值样式
                    color: '#1890FF',
                    fontSize: 16,
                  },
                },
              },
            },
            data: this.numDistributionList
            && this.numDistributionList.map((item) => item.student_num),
          },
          {
            name: '人均学习时长',
            type: 'line',
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: '#1890FF',
              },
            },
            data: this.numDistributionList
            && this.numDistributionList
              .map((item) => Math.ceil(item.learn_total_time / 60 / item.student_num)),
          },
        ],
      };
      myChart.setOption(option);
    },
    // 时间选择切换
    pickChange() {
      if (!this.dateRange) {
        return;
      }
      let selectedDate;
      // type="week" 时，dateRange 可能是单个日期对象或数组
      if (Array.isArray(this.dateRange)) {
        // 如果是数组，取第一个日期
        if (this.dateRange.length < 1) {
          return;
        }
        const [firstDate] = this.dateRange;
        selectedDate = firstDate;
      } else {
        // 如果是单个日期对象，直接使用
        selectedDate = this.dateRange;
      }
      // 计算该周的周一和周日
      const [weekStart, weekEnd] = this.getAlignedWeekRange(selectedDate);
      // 更新 startTime 和 endTime
      this.startTime = weekStart.format('YYYYMMDD');
      this.endTime = weekEnd.format('YYYYMMDD');
      // type="week" 时，dateRange 应该是单个日期对象（周一）
      // 但为了兼容 store 和其他地方，我们同时保存数组格式
      const weekRange = [weekStart.toDate(), weekEnd.toDate()];
      // 更新 dateRange：type="week" 时保持为单个日期对象
      this.dateRange = weekStart.toDate();
      // 发送事件和更新 store（使用数组格式）
      this.bus.$emit('send', weekStart.format('YYYY.MM.DD'), weekEnd.format('YYYY.MM.DD'));
      this.$store.commit('SET_CLASS_DATE_RANGE', weekRange);
      this.getClassSituation();
      this.tagCodeStudySituation();
      this.queryKnowledgeDetailsAction();
    },
    // 打开日期选择器
    openWeekPicker() {
      if (this.$refs.weekPicker) {
        this.$refs.weekPicker.focus();
      }
    },
    getAlignedWeekRange(date) {
      const target = dayjs(date);
      const day = target.day();
      const monday = day === 0 ? target.subtract(6, 'day') : target.subtract(day - 1, 'day');
      const sunday = monday.add(6, 'day');
      return [monday, sunday];
    },
    updateVisible() {
      this.dialogVisible = true;
      this.$refs.dialogContent.pickChange();
    },
    clickItem(index) {
      this.dialogVisible = true;
      this.$refs.dialogContent.clickItem(index);
    },
    queryKnowledgeDetailsAction() {
      console.log(window.location.href, 'dadadadadad');
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
      const params = {
        school_id: userInfo.campusId,
        teacher_id: userInfo.id,
        class_id: this.classId,
        school_master_class_id: this.masterClassId,
        subject_id: this.subjectId,
        course_id: '',
        start_time: this.startTime,
        end_time: this.endTime,
        sort: '',
        descSort: '',
        page: this.currentPage,
        pageSize: this.pageSize,
      };
      getKnowledgeDetailsAction(params).then((res) => {
        this.detailList = res.data.detail;
        this.dataCount = res.data.total;
      });
    },
    tagCodeStudySituation() {
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
      const params = {
        school_id: userInfo.campusId,
        teacher_id: userInfo.id,
        class_id: this.classId,
        school_master_class_id: this.masterClassId,
        subject_id: this.subjectId,
        course_id: '',
        start_time: this.startTime,
        end_time: this.endTime,
      };
      const knowLedgeParams = {
        school_id: userInfo.campusId,
        class_id: this.classId,
        school_master_class_id: this.masterClassId,
        subject_id: this.subjectId,
        course_id: '',
        start_time: this.startTime,
        end_time: this.endTime,
        // dateRange: this.dateRange,
      };
      this.$store.commit('SET_KNOWLEDGE_PARAMS', knowLedgeParams);
      tagCodeStudySituation(params).then((res) => {
        this.effect = res.data.effect;
      });
    },
    knowledgeSizeChange(v) {
      this.pageSize = v;
      this.queryKnowledgeDetailsAction();
    },
    knowledgeCurrentChange(v) {
      this.currentPage = v;
      this.queryKnowledgeDetailsAction();
    },
  },
};
</script>

<style lang="scss" scoped>
.p {
  padding-left: 20px;
  position: relative;
  &-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    &__subject {
      display: flex;
      height: 40px;
      font-size: 14px;
      padding: 2px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 40px;
      background: #F0F2F5;
      border-radius: 4px;
      li {
        width: 90px;
        text-align: center;
      }
    }
    & /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
          width: 240px !important;
        }
    .week-picker-wrapper {
      position: relative;
      display: inline-block;
      .week-picker-input {
        /deep/ .el-input__inner {
          opacity: 0;
          position: absolute;
          z-index: 1;
          cursor: pointer;
        }
      }
      .week-picker-display {
        position: absolute;
        left: 0;
        top: 0;
        width: 240px;
        height: 40px;
        line-height: 40px;
        padding: 0 15px 0 30px;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        background-color: #fff;
        cursor: pointer;
        font-size: 14px;
        color: #606266;
        box-sizing: border-box;
        z-index: 0;
        display: flex;
        align-items: center;
        &:hover {
          border-color: #C0C4CC;
        }
        .el-icon-date {
          position: absolute;
          left: 10px;
          font-size: 16px;
          color: #C0C4CC;
          pointer-events: none;
        }
        span {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .isactive {
      color: #1989FA;
      background: #FFFFFF;
      border-radius: 2px;
    }
  }
  &-people {
    margin-top: 32px;
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    line-height: 24px;
  }
  #myecharts {
    width: 100vw;
    height: 400px;
  }
  .check-detail{
    // display: block;
    position: absolute;
    right: 0;
    top: 55px;
  }
  .overview-head{
    display: flex;
    padding-top:45px;
    align-items: center;
    margin-bottom: 32px;
    &__num{
      font-size: 22px;

      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      margin-right: 14px;
      background:url('~@/views/pt/images/class_bg.png');
      background-size:cover;
      width:38px;
      height:29px;
      line-height: 29px;
      text-align: center;
    }
    &__title{
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
    }
  }
}
</style>
